import React from 'react';
import { FadeIn } from './FadeIn';
import { SectionHeading } from './SectionHeading';
interface TimelineStep {
  number: number;
  title: string;
  description: string;
}
interface ProcessTimelineProps {
  title?: string;
  steps: TimelineStep[];
}
export function ProcessTimeline({
  title = 'Hoe ik werk',
  steps
}: ProcessTimelineProps) {
  return <section className="py-20 md:py-28 bg-warm" data-id="element-168">
      <div className="max-w-5xl mx-auto px-4 md:px-8" data-id="element-169">
        <SectionHeading title={title} data-id="element-170" />

        <div className="relative" data-id="element-171">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-1 bg-gray-200 -translate-y-1/2 z-0" data-id="element-172" />
          <div className="hidden md:block absolute top-1/2 left-0 w-2/3 h-1 bg-gold -translate-y-1/2 z-0" data-id="element-173" />

          {/* Connecting Line (Mobile) */}
          <div className="md:hidden absolute top-0 bottom-0 left-8 w-1 bg-gray-200 z-0" data-id="element-174" />
          <div className="md:hidden absolute top-0 h-2/3 left-8 w-1 bg-gold z-0" data-id="element-175" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-176">
            {steps.map((step, index) => {
            const isLast = index === steps.length - 1;
            return <FadeIn key={step.number} delay={0.1 * (index + 1)} className="flex md:flex-col items-start md:items-center gap-6 md:gap-0" data-id="element-177">
                  <div className={`w-16 h-16 rounded-full flex items-center justify-center text-xl font-bold shadow-md z-10 flex-shrink-0 md:mb-6 ${isLast ? 'bg-navy border-4 border-navy text-white' : 'bg-white border-4 border-gold text-navy'}`} data-id="element-178">
                    {step.number}
                  </div>
                  <div className="md:text-center pt-2 md:pt-0" data-id="element-179">
                    <h3 className="text-xl font-bold text-navy mb-2" data-id="element-180">
                      {step.title}
                    </h3>
                    <p className="text-gray-600" data-id="element-181">{step.description}</p>
                  </div>
                </FadeIn>;
          })}
          </div>
        </div>
      </div>
    </section>;
}